import BigNumber from 'bignumber.js';
import buildQuantityList from 'shared/utils/dropDownHelpers';
import CancelButton from '@material-ui/icons/Cancel';
import compose from 'recompose/compose';
import FunctionButton from 'shared/components/FunctionButton';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import React from 'react';
import Select from '@material-ui/core/Select';
// eslint-disable-next-line import/no-named-default
import { default as CartItemClass } from 'models/CartItem';
import { withStyles } from '@material-ui/core/styles';
import withRouter from '../../../shared/utils/WithRouter';

// Big number accepts numbers up to 15 significant digits before it throws an error. This is because
// precision is lost when converting from a decimal to a binary floating point and back
// ToString will round but at 16 significant digits this shouldn't be a problem.
const subTotalCalc = (quantity, price) => new BigNumber((quantity * price).toString()).toFormat(2);
const handleNav = (id, sku, props) => {
	props.router.navigate(`/product/${id}`, { state: { sku: sku } });
};

const styles = theme => ({
	root: {
		display: 'flex',
		flexDirection: 'row',
		width: '95%',
		height: 131,
		alignItems: 'center',
		borderTopStyle: 'ridge',
		borderTopWidth: 'thin',
	},
	itemImageAll: {
		height: '80%',
		width: '30%',
		marginRight: 10,
	},
	itemImage: {
		objectFit: 'contain',
		width: '75%',
		height: '100%',
		marginRight: 8,
		marginLeft: 26,
	},
	itemInfo: {
		width: 220,
	},
	iconButton: {
		left: '60%',
		bottom: '5%',
		padding: 0,
		color: theme.palette.grey[300],
		backgroundColor: 'transparent',
	},
	functionButtonDiv: {
		marginTop: -126,
		marginLeft: 10,
		padding: 10,
		height: 111,
		width: '85%',
	},
	functionButtonImage: {
		padding: 0,
		width: '100%',
		height: 111,
	},
	functionButtonLabel: {
		padding: 0,
		fontWeight: 'bold',
	},
	itemHeader: {
		display: 'flex',
		flexDirection: 'row',
		width: '100%',
		fontSize: 14,
	},
	menuPaper: {
		maxHeight: '620px',
	},
	quantityDisplay: {
		fontSize: 12,
		margin: 0,
		paddingTop: 6,
	},
	quantitySection: {
		display: 'flex',
		flexDirection: 'row',
		width: '100%',
		fontSize: 12,
	},
	itemPrice: {
		alignSelf: 'center',
		/* subtract the width of the Quantity display and drop down */
		width: 'calc(100% - 148px)',
		textAlign: 'left',
		position: 'relative',
		fontSize: 12,
		fontWeight: 600,
		display: 'inline',
		color: theme.palette.secondary.main,
	},
	itemPriceText: {
		alignSelf: 'center',
		position: 'relative',
		width: 'calc(100% - 148px)',
		textAlign: 'left',
		fontStyle: 'italic',
		fontSize: 12,
		display: 'inline',
	},
	selectInput: {
		color: theme.palette.text.primary,
	},
	selectQuantity: {
		height: '24px',
		fontSize: '12px',
		marginTop: '6px',
		marginLeft: '24px',
		width: '35px',
	},
});
/**
 * Display a single cart item.
 */
const CartItem = props => {
	const { cartItem, classes, handleDelete, handleQuantityChange } = props;
	const itemPrice =
		typeof cartItem.product.price === 'number'
			? new BigNumber(cartItem.product.price).toFormat(2)
			: 0;

	return (
		<div className={classes.root}>
			<div className={classes.itemImageAll}>
				<img className={classes.itemImage} src={cartItem.product.pictureUrl} alt="item" />
				<div className={classes.functionButtonDiv}>
					<FunctionButton
						onClickFunction={() => handleNav(cartItem.product.id, cartItem.product.sku, props)}
						className={classes.functionButtonImage}
					/>
				</div>
				<div className={classes.itemInfo} style={{ marginTop: '-110px', marginLeft: '115%' }}>
					<div className={classes.itemHeader}>
						<FunctionButton
							label={cartItem.product.name}
							onClickFunction={() => handleNav(cartItem.product.id, cartItem.product.sku, props)}
							className={classes.functionButtonLabel}
						/>
					</div>
					<div className={classes.quantitySection} style={{ marginBottom: 16 }}>
						<p className={classes.quantityDisplay}>Quantity:</p>
						<Select
							value={cartItem.quantity}
							disableUnderline
							onChange={event => handleQuantityChange(event, cartItem)}
							className={classes.selectQuantity}
							MenuProps={{
								transformOrigin: { vertical: 'top', horizontal: 'left' },
								getContentAnchorEl: null,
								classes: { paper: classes.menuPaper },
							}}
							inputProps={{ className: classes.selectInput }}
						>
							{buildQuantityList(cartItem.quantity)}
						</Select>
					</div>
					<div>
						<span className={classes.itemPrice}>
							${subTotalCalc(cartItem.quantity, cartItem.product.price)}
						</span>
						&nbsp;&nbsp;
						<span className={classes.itemPriceText}>(${itemPrice} per item)</span>
					</div>
				</div>
			</div>
			<IconButton onClick={() => handleDelete(cartItem.cartId)} className={classes.iconButton}>
				<CancelButton />
			</IconButton>
		</div>
	);
};

CartItem.propTypes = {
	classes: PropTypes.shape({
		root: PropTypes.string,
		functionButtonDiv: PropTypes.string,
		functionButtonImage: PropTypes.string,
		functionButtonLabel: PropTypes.string,
		itemHeader: PropTypes.string,
		itemImageAll: PropTypes.string,
		itemImage: PropTypes.string,
		itemInfo: PropTypes.string,
		itemPrice: PropTypes.string,
		itemPriceText: PropTypes.string,
		iconButton: PropTypes.string,
		menuPaper: PropTypes.string,
		quantityDisplay: PropTypes.string,
		quantitySection: PropTypes.string,
		selectInput: PropTypes.string,
	}).isRequired,
	cartItem: PropTypes.instanceOf(CartItemClass).isRequired,
	handleDelete: PropTypes.func.isRequired,
	handleQuantityChange: PropTypes.func.isRequired,
};

// for testing purposes
export { CartItem as CartItemClassExport };
export default withRouter(compose(withStyles(styles, { name: 'CartItem' }))(CartItem));
